import React, { useCallback, useState } from 'react'
import classNames from 'classnames'
import styles from '../../../CSS/main.css'

type CollapsibleProps = {
  readonly title: string
  readonly isDateRangePicker?: boolean
}
export const Collapsible: React.FC<CollapsibleProps> = ({
  children,
  isDateRangePicker,
  title,
}) => {
  const [open, setOpen] = useState(false)
  const toggle = useCallback(() => {
    setOpen(!open)
  }, [open])

  const menuGroupClasses = classNames({
    [styles.MenuGroup]: true,
    [styles.MenuGroupOpen]: open,
  })

  const menuOptionClasses = classNames({
    [styles.MenuOptions]: true,
    [styles.MenuOptionsOpen]: open,
    [styles.IsDateRangePicker]: !!isDateRangePicker,
  })

  return (
    <div className={menuGroupClasses}>
      <div onClick={toggle} className={classNames([styles.GroupSubhead])}>
        {title}
      </div>
      <div className={menuOptionClasses}>{children}</div>
    </div>
  )
}
